$(document).on("change", "#package_kind", function() {
  $(".package_kind_dependent").removeClass("d-block")
  $(".package_kind_dependent").addClass("d-none")
  $(".package_kind_dependent." + $(this).val()).addClass("d-block")
})
